import { render } from "./tenderInfo.vue?vue&type=template&id=f73f1a48"
import script from "./tenderInfo.vue?vue&type=script&lang=js"
export * from "./tenderInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/tenders/tenders/list/tender/tenderInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f73f1a48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f73f1a48', __exports__)) {
    console.log('reload')
    api.reload('f73f1a48', __exports__)
  }
  
  module.hot.accept("./tenderInfo.vue?vue&type=template&id=f73f1a48", () => {
    console.log('re-render')
    api.rerender('f73f1a48', render)
  })

}


export default __exports__